module.exports = __webpack_public_path__ + "static/b2765ca064f956aacc085539aa78da5a32d6e02e77019022c74d0f596e8bfc27-dd1271e7ac181527c317eefde7bbf44e.jpeg";